import { FAQ } from "@/constants/testIds";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "I'm a homeowner — how do I pay?",
    a: (
      <>
        All payment is sorted on the day with our friendly team — we'll load
        your waste and then take a card payment once we've finished. If you're
        not going to be in at the time of your collection, we do ask for
        payment upfront which is paid via debit or credit card.
      </>
    ),
  },
  {
    q: "I'm a tradesperson — how do I pay?",
    a: (
      <>
        If we haven't worked together before, we do ask for payment upfront
        (sorry, but some of the bad eggs ruin it for the good ones).
        <br />
        <br />
        If you're planning to be on site at the time of your collection, you
        can pay via card once we've cleared your site. If you're not on site,
        then we will not remove the waste until payment is made.
        <br />
        <br />
        If we've worked together a few times, we'll collect the waste and
        issue you with a payment link which is due within 7 days.
      </>
    ),
  },
  {
    q: "Where is the waste disposed of?",
    a: (
      <>
        We work in partnership with North Somerset Environment and dispose of
        all your waste at council-controlled facilities.
      </>
    ),
  },
  {
    q: "How much will a waste clearance cost?",
    a: (
      <>
        We try to be as upfront as we can with our pricing which you can{" "}
        <a
          href="#pricing"
          className="font-semibold text-[var(--kay-pink)] underline underline-offset-4 hover:opacity-80"
        >
          see here
        </a>
        . If you're unsure, please send us a photo via WhatsApp and we can
        give you an estimate.
      </>
    ),
  },
  {
    q: "Can you take sofas, mattresses and appliances?",
    a: (
      <>
        Yes we can — please contact us for an accurate price as bulky items
        take up lots of space!
      </>
    ),
  },
  {
    q: "How quickly can you collect?",
    a: (
      <>
        We can often collect the same week, but often even sooner! When you
        book a collection, we'll always try to get to you at your preferred
        time, but we'll contact you to confirm your appointment once you have
        booked.
      </>
    ),
  },
  {
    q: "Do you cover my area?",
    a: (
      <>
        We generally cover all BS &amp; TA postcodes. If you're not sure, then
        get in touch!
      </>
    ),
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid={FAQ.root}
      className="border-b-2 border-black bg-[var(--kay-bg)]"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-20 md:px-8 md:py-28 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-[var(--kay-pink)]">
            FAQ
          </div>
          <h2 className="font-display text-4xl uppercase leading-none sm:text-5xl md:text-6xl">
            Everything
            <br />
            you might
            <br />
            <span className="text-[var(--kay-pink)]">be wondering.</span>
          </h2>
          <p className="mt-6 max-w-md text-neutral-600">
            We'll expand this section soon. Got a question we haven't answered?
            Mention it in your booking notes.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="border-2 border-black bg-white hard-shadow">
            {ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={FAQ.item(i)}
                className="border-b-2 border-black last:border-b-0"
              >
                <AccordionTrigger className="px-5 py-5 text-left font-display text-lg uppercase tracking-tight hover:no-underline sm:text-xl">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="px-5 pb-5 text-neutral-700">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
